<div id ="edit-floating-menu-container" class="edit-floating-menu" *ngIf="editFloatingMenuControl?.visible"> 
  <div id="button-group">
    <button type="button" mat-button class="individual-button responsive-button-2 save-button" (click)="saveClicked()" i18n="Save Changes|@@Save_Changes">Save Changes</button>
    <button type="button" mat-button class="secondary-button responsive-button-2" (click)="cancelClicked()" i18n="Cancel|@@Cancel">Cancel</button>
  </div>
</div>
<div class="edit-floating-menu-spacer" *ngIf="editFloatingMenuControl?.visible"></div>